import { useMemo } from 'react'

import { User } from './user'

export function useNextAutoscanDate(
  user: User | null | undefined,
): Date | null | undefined {
  return useMemo(() => {
    // User not loaded
    if (user === undefined) {
      return undefined
    }

    // No user or no next autoscan date
    if (user === null || !user.nextAutoscanDate) {
      return null
    }

    return new Date(user.nextAutoscanDate)
  }, [user])
}
